var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-list-select" }, [
    _c(
      "div",
      { staticClass: "search-list-select__search mb-1" },
      [
        _vm.search
          ? _c("common-search-field", {
              attrs: { placeholder: "Найти", disabled: _vm.disabled },
              model: {
                value: _vm.searchQuery,
                callback: function ($$v) {
                  _vm.searchQuery = $$v
                },
                expression: "searchQuery",
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.disabled,
            expression: "!disabled",
          },
        ],
        staticClass: "search-list-select__list",
      },
      [
        _c("selection-list", {
          attrs: {
            items: _vm.items,
            value: _vm.value,
            mandatory: _vm.mandatory,
            "search-query": _vm.searchQuery,
          },
          on: { change: _vm.handleSelect, input: _vm.handleInput },
          scopedSlots: _vm._u(
            [
              {
                key: "not-found",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "mt-14 d-flex flex-column align-center" },
                      [
                        _c("img", {
                          staticClass: "mb-6",
                          attrs: {
                            src: "/static/_v1/pd/icons/empty-search-result/common.svg",
                            width: "60",
                            height: "60",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-body-1 text--text" }, [
                          _vm._v("Мы ничего не нашли"),
                        ]),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "item-content",
                fn: function ({ item }) {
                  return [_vm._t("list-item-content", null, null, { item })]
                },
              },
            ],
            null,
            true
          ),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }